import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import moment from 'moment-timezone'
import { Link } from 'react-router-dom'
import { LAST_THREE_EVENT_UPDATED } from '../query/event'
moment.locale('fr')

class CurrentEventListComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      events: this.updateMetricStructure(props.refuelEvents)
    }
  }

  updateMetricStructure (events) {
    const beautifyEvents = []
    events.forEach(function (element, key) {
      beautifyEvents.push({
        time: moment.utc(element.end_at).tz('Indian/Antananarivo').format('HH:mm'),
        state: 'Plein',
        imm: element.registration_number,
        trackable_label: element.trackable_label
      })
    })
    return beautifyEvents
  }

  eventList () {
    const vehicleDisplayMode = localStorage.getItem('vehicleDisplayMode') || 'registration'

    return this.state.events.map((data, key) => {
      let displayValue = data.imm

      // If vehicleDisplayMode is not 'registration', use trackable.name
      if (vehicleDisplayMode !== 'registration') {
        const trackable = this.props.trackables.find(t => t.label === data.trackable_label)
        if (trackable && trackable.name) {
          displayValue = trackable.name
        }
      }

      return (
        <div key={key} style={styles.tableContent}>
          <table style={styles.table}>
            <tbody>
              <tr style={styles.line}>
                <td style={styles.colTime}>
                  {data.time}
                </td>
                <td style={styles.colRegistration}>
                  {displayValue}
                </td>
                <td style={styles.colState}>
                  {data.state}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    })
  }

  render () {
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='EVENEMENTS RECENTS'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            {this.eventList()}
          </div>
          <div style={styles.contentButton}>
            <Link style={styles.link} to='events'>
              <div style={styles.button}>OK</div>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  link: {
    textDecoration: 'none'
  },
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '220px',
    marginTop: '12px',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  tableContent: {
    marginLeft: '24px',
    marginRight: '24px'
  },
  table: {
    width: '100%'
  },
  line: {
    height: '32px'
  },
  colTime: {
    textAlign: 'left',
    width: '33%',
    color: '#F2F2F2',
    fontSize: '14px',
    fontWeight: 500
  },
  colRegistration: {
    textAlign: 'left',
    width: '33%',
    color: '#F2F2F2',
    fontSize: '14px',
    fontWeight: 500
  },
  colState: {
    textAlign: 'right',
    width: '34%',
    color: '#F2F2F2',
    fontSize: '14px',
    fontWeight: 500
  },
  contentButton: {
    height: '48px',
    width: '100%'
  },
  button: {
    textAlign: 'center',
    paddingTop: '12px',
    marginLeft: '24px',
    marginRight: '24px',
    // marginTop: '18px',
    marginTop: '22px',
    height: '30px',
    borderRadius: '22px',
    borderColor: '#7ED321',
    borderWidth: '1px',
    borderStyle: 'solid',
    fontSize: '14px',
    fontWeight: 500,
    color: '#7ED321'
  }

}

export default CurrentEventListComponent
